import { memo } from 'react'

import { Feature } from '@wwt/entities/search-response'

import { cn } from '@/shared/lib/cn'

import { FeatureListElements } from './FeatureListElements.tsx'

interface FeatureListProps {
	className?: string
	features: Feature[]
}

/**
 * List of features
 *
 * @author Ivan Shchedrovskyi
 */
export const FeatureList = memo(({ className, features }: FeatureListProps) => {
	return (
		<div
			className={cn(
				'grid gap-x-10 gap-y-4',
				'grid-cols-[1fr] md:grid-cols-[1fr_1fr] xl:grid-cols-[1fr_1fr_1fr]',
				className
			)}
		>
			<FeatureListElements
				features={features}
				forceIsClickable={false}
			/>
		</div>
	)
})

FeatureList.displayName = 'FeatureList'
